
/* injects from baggage-loader */

import loadTypes from 'utils/loadTypes'
import steps from './steps'

export const CONFIRM_STEP = loadTypes('CONFIRM_STEP')
export const GET_STATUS = loadTypes('GET_STATUS')
export const INIT_STATE = 'ONBOARD_INIT_STATE'

const initialState = {
  siteId: null,
  isInited: false,
  isOnboardSuccess: false,
  isLoadedStep: false,
  steps: [...steps]
}

const updateSteps = (steps, stepToUpdate, newStatus) => {
  return steps.map(s =>
    s.step === stepToUpdate ? {...s, status: newStatus} : s
  )
}

const mergeSteps = (stateSteps, responseSteps) => {
  return stateSteps.map(stateStep => {
    const matchingResponseStep = responseSteps.find(
      responseStep => responseStep.step === stateStep.step
    )
    return matchingResponseStep
      ? {...stateStep, ...matchingResponseStep}
      : stateStep
  })
}

const checkAllStepsCompleted = (siteId, steps) => {
  const stepNotCompleted = steps.find(step => step.status !== 'completed')
  if (!stepNotCompleted) {
    localStorage.setItem(`onboarded-${siteId}`, true)
  }
  return !stepNotCompleted
}

export default function onboard(state = initialState, action) {
  switch (action.type) {
    case INIT_STATE:
      const siteId = action.siteId
      const isOnboardSuccess = !!localStorage.getItem(`onboarded-${siteId}`)
      return {
        ...state,
        siteId,
        isInited: true,
        isOnboardSuccess
      }
    case CONFIRM_STEP.REQUEST:
      const {step} = action.request.body
      const newSteps = updateSteps(state.steps, step, 'completed')
      return {
        ...state,
        steps: newSteps,
        isOnboardSuccess: checkAllStepsCompleted(state.siteId, newSteps)
      }

    case GET_STATUS.SUCCESS:
      const responseSteps = action.response
      const mergedSteps = mergeSteps(state.steps, responseSteps)
      return {
        ...state,
        isLoadedStep: true,
        steps: mergedSteps,
        isOnboardSuccess: checkAllStepsCompleted(state.siteId, mergedSteps)
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./client/redux/modules/onboard/index.js